import { render, staticRenderFns } from "./estudantesListagemAntigo.vue?vue&type=template&id=093ccc0c&scoped=true&"
import script from "./estudantesListagemAntigo.vue?vue&type=script&lang=js&"
export * from "./estudantesListagemAntigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ccc0c",
  null
  
)

export default component.exports